import React from 'react';
import {
  PieChart, Pie, Sector, Cell,
} from 'recharts';

const data = [
  { name: 'Group A', value: 400 },
  { name: 'Group B', value: 300 },
  { name: 'Group C', value: 300 },
  { name: 'Group D', value: 200 },
];
const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];


 const ChartsItem = () => {

 
    return (
      <PieChart width={100} height={100} >
        <Pie
          data={data}
          innerRadius={40}
          outerRadius={50}
          fill="#8884d8"
          paddingAngle={3}
          dataKey="value"
        >
          {
            data.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />)
          }
        </Pie>
      </PieChart>
    );
  
}
export default ChartsItem;